import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import {AuthService} from '../services/auth.service';
import {Authority} from '../models/authority';
import {Subscription} from 'rxjs';

@Directive({
    selector: '[appHasRole]',
    standalone: false
})
export class HasRoleDirective implements OnInit, OnDestroy {
    private authService = inject<AuthService>('AuthService' as any);
    private templateRef = inject<TemplateRef<any>>(TemplateRef);
    private viewContainer = inject(ViewContainerRef);

    @Input('appHasRole') public roles: Authority[] = [];

    subscription = new Subscription();

    viewCreated = false;

    ngOnInit(): void {
        this.subscription.add(
            this.authService.authorities$.subscribe(authorities => {
                if (authorities.some(authority => this.roles.includes(authority))) {
                    if (!this.viewCreated) {
                        this.viewContainer.createEmbeddedView(this.templateRef);
                        this.viewCreated = true;
                    }
                } else {
                    this.viewContainer.clear()
                    this.viewCreated = false
                }
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
